import { call, put, takeLatest } from "redux-saga/effects";
import {
  createQuizathonFailure,
  createQuizathonStart,
  createQuizathonSuccess
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { httpCreateQuizathon } from "../../../services/quizathon";
import { successNotifier } from "../../../utils/helpers";

export function* createQuizathon({ payload }) {
  const { data, callback } = payload;
  const response = yield call(httpCreateQuizathon, data);
  const { success, raw, message } = response;

  if (success) {
    yield put(createQuizathonSuccess());
    successNotifier("quizathon created successfully");
    if (callback) {
      callback();
    }
  } else {
    yield put(createQuizathonFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onCreateQuizathon() {
  yield takeLatest(createQuizathonStart.type, createQuizathon);
}
